import React, { useEffect, useRef, useState } from 'react'
import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import { Delegator } from '@evertel/schema-parser'

interface RowProps {
    id?: string
    value: any
    errors: any
    items: any
    className?: string
    documentId?: number
    schemaId?: number
}

const Row: React.FC<RowProps> = observer(({
    id,
    value: parentValue,
    errors: parentErrors,
    items,
    className,
    ...otherProps
}) => {

    const [isNarrow, setIsNarrow] = useState(false)
    const rowRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (!rowRef.current) return

        const observer = new ResizeObserver(entries => {
            for (const entry of entries) {
                setIsNarrow(entry.contentRect.width < 400)
            }
        })

        observer.observe(rowRef.current)
        return () => observer.disconnect()
    }, [])

    if (!items?.length) return null

    // Remove overrideId from otherProps
    // this is moved over to Wrapper.tsx
    // delete otherProps.overrideId // (comes from Normalize)

    const colSize = 12 / items.length
    const colClass = `${isNarrow ? 'col-xs-12' : `col-sm-${colSize}`}`

    //For rows that aren't a list we need to set the margins/negative-margins for spacing between inputs
    //if we don't limit this, then the classes from the root rows will be propagated to all Delegate items
    const nextIsList = items[0].type === 'list'

    return (
        <div ref={rowRef} className={classNames('evertel-row', {'m-n4': !nextIsList, 'my-4': nextIsList})}>
            {items.map(({id: itemId, overrideId, ...itemProps}, i: number) => {
                //console.log('ROW ITEM', {itemId}, {parentValue}, {overrideId}, parentValue[overrideId], itemProps)

                // workaround for bad data in legacy schema data structure
                if (parentValue && overrideId && parentValue[overrideId]) itemId = overrideId

                const itemValue = parentValue?.[itemId]
                const itemErrors = parentErrors?.[itemId]


                const delegatorClassName = classNames('', {
                    'p-4': !nextIsList,
                    [colClass]: !nextIsList
                })

                return (
                    <Delegator
                        key={i}
                        {...otherProps}
                        {...itemProps}
                        id={itemId}
                        value={itemValue}
                        errors={itemErrors}
                        className={delegatorClassName}
                    />
                )
            })}
        </div>
    )
})

export { Row }
Row.displayName = 'Row (Schema)'
